import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IPageShownCounters } from './definitrions';

const initialState: IPageShownCounters = {};

const pageShownCountersSlice = createSlice({
  name: 'pageShownCounters',
  initialState,
  reducers: {
    setPageShownCounters(state, action: PayloadAction<IPageShownCounters>) {
      state = action.payload;
      return state;
    },
    clearPageShownCounters(state) {
      return { ...initialState };
    },
  },
});

export const { setPageShownCounters, clearPageShownCounters } = pageShownCountersSlice.actions;
export default pageShownCountersSlice.reducer;
